import React, { useEffect, useCallback, useMemo, useRef, useState } from "react";
import { SubTabControls } from "@/pages/dashboard/dashboard.main.subTabPanel";
import { useSelector, useDispatch } from "react-redux";
import {
  Switch,
  Skeleton,
  Button,
  Card,
  Input,
} from "antd";
import FilterActionButtons from '@/common/filter-action-buttons';
//import LayoutToggleComponent from "@/common/layout-toggle";
import { getDashboardFilters } from "@/common/document-filters/document-filters-reducer";
import {
  setFilter,
  setSelectedTableItems,
  clearFilter,
  setAllTableSiteId,
} from "@/pages/shared/shared.reducer";
import get from "lodash.get";
import {
  setCurrentPage,
  selectCurrentDashboardFields,
} from "@/pages/dashboard/dashboard.slice";
import MultipleSelect from "@/common/document-filters/multiple-select";
import SingleSelect from "@/common/document-filters/single-select";
import { Hint } from "@/common/hint";
import "./document-filters-component.less";

export const applyDisabledFilterSelection = ({
  siteId,
  filterName,
  disabledSelection,
  clearFilter,
  setFilter,
  resetSearch,
  resetLocalSearch,
}) => {
  resetSearch?.();
  resetLocalSearch?.();
  clearFilter(siteId);
  setFilter(filterName, disabledSelection);
};

const FilterHeader = ({ 
  width, 
  closeFilterDrawer, 
  sideView,
  getAllRevisionFilter, 
  //layoutToggle = null 
}) => (
  <div
    className="display-center"
    style={sideView ? {display: "flex", justifyContent: "space-between"} : { display: "flex", gap: "20px"}}
  >
    <div className="heading-03">Filters</div>
    {width > 1440 ? (
      <div
        className="display-center"
        style={{ gap: "8px", fontSize: "12px" }}
      >
        {getAllRevisionFilter()}
        <div>Show all revisions</div>
        <Hint
          icon="ri-question-line"
          className="document-filter-revisions-help"
          popoverText="See all document files including previous revisions in the document list."
          placement="bottomRight"
          width={300}
        />
      </div>
    ) : (
      <>
        {/* {layoutToggle} */}
        <Button
          className="display-center custom-close-modal"
          onClick={() => closeFilterDrawer()}
        >
          <i className="ri-close-line"></i>
          Close
        </Button>
      </>
      )}
  </div>
);

const SearchInputs = ({ 
  searchBarRef, 
  ddvSearch, 
  setDdvSearch, 
  handleSearch, 
  descriptionSearch, 
  altSearch, 
  setAltSearch, 
  setDescriptionSearch 
}) => (
  <div
    ref={searchBarRef}
    style={{
      display: "flex",
      gap: "15px",
      alignItems: "center",
      flexDirection: "column",
      marginTop: "10px",
    }}
  >
    <Input
      rootClassName="documents document-search"
      prefix={
        <i
          className="ri-search-line"
          style={{ cursor: "auto" }}
        />
      }
      suffix={
        ddvSearch && (
          <i
            className="ri-close-line"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setDdvSearch("");
              handleSearch("", descriptionSearch, altSearch);
            }}
          />
        )
      }
      placeholder="Search document/drawing # or vendor #"
      style={{ fontSize: "12px" }}
      value={ddvSearch}
      onChange={(e) => setDdvSearch(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter")
          handleSearch(ddvSearch, descriptionSearch, altSearch);
      }}
    />
    {setAltSearch && (
      <Input
        rootClassName="description"
        prefix={
          <i
            className="ri-search-line"
            style={{ cursor: "auto" }}
          />
        }
        suffix={
          altSearch && (
            <i
              className="ri-close-line"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setAltSearch("");
                handleSearch(ddvSearch, descriptionSearch, "");
              }}
            />
          )
        }
        placeholder="altSearchText"
        style={{ fontSize: "12px" }}
        value={altSearch}
        onChange={(e) => setAltSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter")
            handleSearch(ddvSearch, descriptionSearch, altSearch);
        }}
      />
    )}
    {setDescriptionSearch && (
      <Input
        rootClassName="description description-search"
        prefix={
          <i
            className="ri-search-line"
            style={{ cursor: "auto" }}
          />
        }
        suffix={
          descriptionSearch && (
            <i
              className="ri-close-line"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDescriptionSearch("");
                handleSearch(ddvSearch, "", altSearch);
              }}
            />
          )
        }
        placeholder="Search description"
        style={{ fontSize: "12px" }}
        value={descriptionSearch}
        onChange={(e) => setDescriptionSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter")
            handleSearch(ddvSearch, descriptionSearch, altSearch);
        }}
      />
    )}
  </div>
);

const FilterActions = ({ 
  filterActionRef, 
  handleSearch, 
  ddvSearch, 
  descriptionSearch, 
  altSearch,
  handleClearAll, 
  resetSearch, 
  resetLocalSearch,
  sideView,
  shouldAttachRef = true
}) => (
  <div
    style={sideView ? { margin: "8px" } : {
      display: "flex",
      gap: 6,
      padding: "8px 12px",
      float: "right",
    }}
  >
    {sideView ? (
      <FilterActionButtons
        onApply={() => handleSearch(ddvSearch, descriptionSearch, altSearch)}
        onReset={() => {
          handleClearAll(false);
          resetSearch();
          resetLocalSearch();
        }}
      />
    ) : (
      <div
        ref={shouldAttachRef ? filterActionRef : null}
      >
        <Button
          type="primary"
          className="display-center"
          onClick={() => handleSearch(ddvSearch, descriptionSearch, altSearch)}
        >
          <div
            style={{
              display: "flex",
              margin: "8px",
              gap: "6px",
            }}
            className="display-center"
          >
            <i
              style={{ fontSize: 16 }}
              className="ri-checkbox-circle-line"
            ></i>
            <div>Apply</div>
          </div>
        </Button>
        <Button
          title="Reset All"
          className="display-center reset-filter-button"
          onClick={() => {
            handleClearAll(false);
            resetSearch();
            resetLocalSearch();
          }}
          style={{ marginLeft: '8px' }}
        >
          Reset
        </Button>
      </div>
    )}
  </div>
);

const FilterControls = ({ 
  ignoreSite, 
  getSiteFilter, 
  getDocumentStatusFilter, 
  getCategoryFilter, 
  getSubCategoryFilter, 
  renderCustomFilters, 
  filters, 
  sideView,
  getAllRevisionFilter,
  width
}) => {
  const items = (
    <>
      {!ignoreSite && (
        <div className="document-filter-field document-filter-field--site">
          {getSiteFilter()}
        </div>
      )}
      {sideView ? (
        <>
          <div className="document-filter-field">
            {getDocumentStatusFilter()}
          </div>
          <div className="document-filter-field document-filter-field--category">
            {getCategoryFilter()}
          </div>
          <div className="document-filter-field document-filter-field--category">
            {getSubCategoryFilter()}
          </div>
          {renderCustomFilters(filters)}
        </>
      ) : (
        <>
          <div className="document-filter-field">{getDocumentStatusFilter()}</div>
          {width <= 1440 && (
            <div>
              <div className="display-center" style={{ gap: "8px" }}>
                {getAllRevisionFilter()}
                <div style={{ fontSize: 12 }}>Show all revisions</div>
                <Hint
                  icon="ri-question-line"
                  className="document-filter-revisions-help"
                  popoverText="See all document files including previous revisions in the document list."
                  placement="bottomRight"
                  width={300}
                />
              </div>
            </div>
          )}
          <div className="document-filter-field document-filter-field--category">
            {getCategoryFilter()}
          </div>
          <div className="document-filter-field document-filter-field--category">
            {getSubCategoryFilter()}
          </div>
        </>
      )}
    </>
  );

  if (!sideView) {
    // TopViewLayout owns the outer grid so it can unify these with custom
    // filters and the Apply/Reset actions in a single responsive row.
    return items;
  }

  return (
    <div
      style={{
        rowGap: "8px",
        display: "grid",
        width: "100%",
        marginTop: "8px",
        marginBottom: "12px",
      }}
    >
      {items}
    </div>
  );
};

const DefaultSideViewLayout = ({ 
  width, 
  closeFilterDrawer, 
  getAllRevisionFilter,
  currentDashboard,
  tableCount,
  setLargeTableView,
  setThumbnailTableView,
  isCartTab,
  table,
  searchBarRef,
  ddvSearch,
  setDdvSearch,
  handleSearch,
  descriptionSearch,
  altSearch,
  setAltSearch,
  setDescriptionSearch,
  children,
  filterActionRef,
  filterRef,
  actions,
  shouldAttachFilterRef = true,
  //layoutToggle
}) => (
  <div className="side-filter document-filter-panel">
    <Card
      ref={shouldAttachFilterRef ? filterRef : null}
      className="side-filter-card document-filter-panel__card"
      styles={{
        body: {
          borderRadius: "0px !important",
          overflow: "auto",
          minHeight: 0,
        },
        header: {
          borderBottom: "2px solid var(--dms-color-border-strong)",
          overflow: "hidden",
          height: "56px",
        },
      }}
      title={
        <FilterHeader 
          width={width} 
          closeFilterDrawer={closeFilterDrawer} 
          sideView={true}
          getAllRevisionFilter={getAllRevisionFilter}
        />
      }
    >
      <div className="document-filter-panel__controls">
        {/* {width <= 1440 && width >= 768 && (
          <Flex vertical gap="middle">
            {layoutToggle} 
            <div></div>
          </Flex>
        )} */}
        {width < 768 && (
          <>
            <SubTabControls
              setLargeTableView={setLargeTableView}
              setThumbnailTableView={setThumbnailTableView}
              isCartTab={isCartTab}
              width={width}
              inDrawer={true}
              allSites={currentDashboard === "allSitesDashboard"}
              totalCount={tableCount}
              tableId={table}
            />
            <SearchInputs 
              searchBarRef={searchBarRef}
              ddvSearch={ddvSearch}
              setDdvSearch={setDdvSearch}
              handleSearch={handleSearch}
              descriptionSearch={descriptionSearch}
              altSearch={altSearch}
              setAltSearch={setAltSearch}
              setDescriptionSearch={setDescriptionSearch}
            />
          </>
        )}
        {children}
      </div>
    </Card>
    <Card
      ref={filterActionRef}
      className="side-filter-footer document-filter-panel__footer"
    >
      {actions}
    </Card>
  </div>
);

const TopViewLayout = ({ 
  showFilterDrawer, 
  width, 
  closeFilterDrawer, 
  getAllRevisionFilter,
  children,
  filterRef,
  actions,
  customFilters,
  shouldAttachFilterRef = true,
  //layoutToggle
}) => (
  <div className="document-top-filters document-filter-panel--top">
    <Card
      ref={shouldAttachFilterRef ? filterRef : null}
      className="document-filter-panel__top-card"
      styles={{
        header: {
          overflow: "hidden"
        },
        body: {
          borderRadius: "0px !important",
          overflowY: "auto",
          maxHeight: `${showFilterDrawer ? "29vh" : "22vh"}`,
        },
      }}
      title={
        <FilterHeader 
          width={width} 
          closeFilterDrawer={closeFilterDrawer} 
          sideView={false}
          getAllRevisionFilter={getAllRevisionFilter}
          //layoutToggle={layoutToggle}
        />
      }
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: "12px",
          alignItems: "end",
          padding: "0px 20px 0px 10px",
        }}
      >
        {children}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px 12px",
          alignItems: "flex-end",
          marginTop: "12px",
          padding: "0px 20px 20px 10px",
        }}
      >
        {React.Children.map(customFilters, (child, i) => (
          <div
            key={i}
            style={{
              flex: "1 1 calc((100% - 6 * 12px) / 7)",
              minWidth: 0,
              maxWidth: `calc((100% - 6 * 12px) / 7)`,
            }}
          >
            {child}
          </div>
        ))}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginLeft: "auto",
          }}
        >
          {actions}
        </div>
      </div>
    </Card>
  </div>
);

export const DocumentFiltersComponent = (props) => {
  const {
    categories,
    subCategories,
    allCategories,
    allSubCategories,
    documentStatusList,
    filters,
    includeCart = false,
    cartDocumentIds,
    resetSearch,
    showFilterDrawer,
    getDocumentFilters,
    setCurrentPage,
    updateTotalDocumentCount,
    tableCount,
    setLargeTableView,
    setThumbnailTableView,
    isCartTab,
    setAltSearch: propSetAltSearch,
    altSearch: propAltSearch,
    setDescriptionSearch: propSetDescriptionSearch,
    setDdvSearch: propSetDdvSearch,
    width = window.innerWidth,
    descriptionSearch: propDescriptionSearch,
    ddvSearch: propDdvSearch,
    closeFilterDrawer,
    searchBarRef,
    setFilter: propSetFilter,
    clearFilter: propClearFilter,
    clearSelectedItems,
    handleSearch: propHandleSearch,
    currentSiteId,
    loadingAllFilters,
    documentFilters: propDocumentFilters,
    ignoreSite,
    table,
    filterActionRef,
    filterRef,
  } = props;
  
  const dispatch = useDispatch();
  const {
    sideView,
    currentDashboard,
  } = useSelector(selectCurrentDashboardFields);

  const prevTableRef = useRef(currentDashboard);

  // The custom filter the user last interacted with. It keeps its own option
  // list while the others refresh, so it must not show a loading state.
  const [activeCustomFilter, setActiveCustomFilter] = useState(null);
  const [wasLoadingAllFilters, setWasLoadingAllFilters] = useState(loadingAllFilters);

  if (wasLoadingAllFilters !== loadingAllFilters) {
    setWasLoadingAllFilters(loadingAllFilters);
    if (!loadingAllFilters) {
      setActiveCustomFilter(null);
    }
  }
  
  // Use props for search fields - shared with SubTabButtons via Dashboard parent
  const ddvSearch = propDdvSearch || "";
  const setDdvSearch = useMemo(() => propSetDdvSearch || (() => {}), [propSetDdvSearch]);
  const descriptionSearch = propDescriptionSearch || "";
  const setDescriptionSearch = useMemo(() => propSetDescriptionSearch || (() => {}), [propSetDescriptionSearch]);
  const altSearch = propAltSearch || "";
  const setAltSearch = useMemo(() => propSetAltSearch || (() => {}), [propSetAltSearch]);
  
  const sites = useSelector((state) => state.dashboardPage.sites);
  const sitesLoading = useSelector((state) => state.dashboardPage.loading);

  const handleSearch = useCallback((docSearch, descSearch, altSch) => {
    if (propHandleSearch) {
      propHandleSearch(docSearch, descSearch, altSch);
    }
  }, [propHandleSearch]);

  const resetLocalSearch = useCallback(() => {
    setDdvSearch("");
    setDescriptionSearch("");
    setAltSearch("");
  }, [setDdvSearch, setDescriptionSearch, setAltSearch]);

  const stableFilters = useMemo(
    () => ({
      ...filters,
      ...(includeCart && { cartDocumentIds }),
    }),
    [filters, includeCart, cartDocumentIds]
  );
  const prevFiltersRef = useRef(stableFilters);

  const handleFilterChange = useCallback(
    (filtersArg, includeAllCategories, shouldResetPage = true) => {
      if (shouldResetPage) {
        setCurrentPage(1);
      }
      if (includeAllCategories) {
        propSetFilter("documentStatusId", 1);
      }

      getDocumentFilters(filtersArg, includeAllCategories);
    },
    [setCurrentPage, propSetFilter, getDocumentFilters]
  );

  const handleClearAll = useCallback(
    (siteId) => {
      clearSelectedItems();
      propClearFilter(siteId || null);
      propSetFilter("documentStatusId", 1);
    },
    [clearSelectedItems, propClearFilter, propSetFilter]
  );

  useEffect(() => {
    if (includeCart && cartDocumentIds.length > 0) {
      getDocumentFilters(stableFilters, true);
    }
  }, [includeCart, cartDocumentIds, stableFilters, getDocumentFilters]);

  useEffect(() => {
    if (currentDashboard !== prevTableRef.current) {
      handleFilterChange(stableFilters, true, false);
      prevTableRef.current = currentDashboard;
    } else if (JSON.stringify(stableFilters) !== JSON.stringify(prevFiltersRef.current)) {
      const siteChange = stableFilters.siteId !== prevFiltersRef.current.siteId;
      
      const normalizeFilters = (f) => {
        const normalized = { ...f };
        Object.keys(normalized).forEach(key => {
          const val = normalized[key];
          if (Array.isArray(val)) {
            normalized[key] = val.length === 0 ? "" : val.join(' ');
          }
        });
        return normalized;
      };
      
      // Check if only currentPage changed (don't reset page for currentPage-only changes)
      // Note: pageSize changes MUST trigger handleFilterChange to reset currentPage to 1,
      // otherwise changing to a larger pageSize can leave currentPage out of bounds (no results).
      const filtersWithoutPagination = normalizeFilters({ ...stableFilters });
      const prevFiltersWithoutPagination = normalizeFilters({ ...prevFiltersRef.current });
      delete filtersWithoutPagination.currentPage;
      delete prevFiltersWithoutPagination.currentPage;
      
      const onlyPaginationChanged = JSON.stringify(filtersWithoutPagination) === JSON.stringify(prevFiltersWithoutPagination);

      if (onlyPaginationChanged) {
        prevFiltersRef.current = stableFilters;
        return;
      }
      
      handleFilterChange(stableFilters, siteChange, true);
      prevFiltersRef.current = stableFilters;
      if (siteChange) {
        if (updateTotalDocumentCount) updateTotalDocumentCount();
      }
    }
  }, [stableFilters, currentDashboard, handleFilterChange, updateTotalDocumentCount]);

  const createSingleSelect = useCallback((id, title, options, initialSelect, onSelect) => (
    <SingleSelect
      id={id}
      title={title}
      width="100%"
      options={options}
      onSelect={onSelect}
      initialSelect={initialSelect}
    />
  ), []);

  const createMultipleSelect = useCallback((title, options, value, onSelect, onClear, loading = false) => (
    <MultipleSelect
      title={title}
      options={options}
      onSelect={onSelect}
      onClear={onClear}
      value={value}
      loading={loading}
      selectedOnInit={value?.map((x) => ({ key: x, label: x }))}
    />
  ), []);

  const getSiteFilter = () => {
    const options = sites.map((x) => ({
      label: x.siteFullName,
      key: x.siteId,
    }));
    const onSelect = (siteId) => {
      resetSearch();
      handleClearAll(siteId);
      setTimeout(() => {
        setCurrentPage(1);
        dispatch(setAllTableSiteId(siteId));
        propHandleSearch && propHandleSearch("", "");
      }, 0);
    };

    return !(filters.siteId in filters) && sitesLoading ? (
      <Skeleton.Input active={true} />
    ) : (
      createSingleSelect(
        "site",
        "Site",
        options,
        options.find((x) => x.key === (filters.siteId || currentSiteId))
          ?.key,
        (value) => onSelect(value.key)
      )
    );
  };

  const getCategoryFilter = useCallback(() => {
    const enabledCategoryOptions = allCategories
      .filter((item) =>
        categories.find(
          (element) => element.toLowerCase() === item.toLowerCase()
        )
      )
      .map((item) => ({ key: item, label: item, disabled: false }));

    const disabledCategoryOptions = allCategories
      .filter(
        (item) =>
          !categories.find(
            (element) => element.toLowerCase() === item.toLowerCase()
          )
      )
      .map((item) => ({ key: item, label: item, disabled: true }));

    const disabledKeys = disabledCategoryOptions.map((opt) => opt.key.toLowerCase());

    const handleCategorySelect = (value) => {
      const newSelections = Array.isArray(value) ? value : [];
      const hasDisabledSelection = newSelections.some(
        (selected) => disabledKeys.includes(selected.toLowerCase())
      );

      if (hasDisabledSelection) {
        const disabledSelection = newSelections.filter(
          (selected) => disabledKeys.includes(selected.toLowerCase())
        );
        applyDisabledFilterSelection({
          siteId: filters.siteId,
          filterName: "category",
          disabledSelection,
          clearFilter: propClearFilter,
          setFilter: propSetFilter,
          resetSearch,
          resetLocalSearch,
        });
      } else {
        propSetFilter("category", value);
      }
    };

    return createMultipleSelect(
      "Category",
      [...enabledCategoryOptions, ...disabledCategoryOptions],
      filters["category"] || null,
      handleCategorySelect,
      () => propSetFilter("category", "")
    );
  }, [
    categories,
    allCategories,
    filters,
    propSetFilter,
    propClearFilter,
    resetSearch,
    resetLocalSearch,
    createMultipleSelect,
  ]);

  const getSubCategoryFilter = useCallback(() => {
    const enabledSubCategoryOptions = allSubCategories
      .filter((item) =>
        subCategories.find(
          (element) => element.toLowerCase() === item.toLowerCase()
        )
      )
      .map((item) => ({ key: item, label: item, disabled: false }));

    const disabledSubCategoryOptions = allSubCategories
      .filter(
        (item) =>
          !subCategories.find(
            (element) => element.toLowerCase() === item.toLowerCase()
          )
      )
      .map((item) => ({ key: item, label: item, disabled: true }));

    const disabledKeys = disabledSubCategoryOptions.map((opt) => opt.key.toLowerCase());

    const handleSubCategorySelect = (value) => {
      const newSelections = Array.isArray(value) ? value : [];
      const hasDisabledSelection = newSelections.some(
        (selected) => disabledKeys.includes(selected.toLowerCase())
      );

      if (hasDisabledSelection) {
        const disabledSelection = newSelections.filter(
          (selected) => disabledKeys.includes(selected.toLowerCase())
        );
        applyDisabledFilterSelection({
          siteId: filters.siteId,
          filterName: "subCategory",
          disabledSelection,
          clearFilter: propClearFilter,
          setFilter: propSetFilter,
          resetSearch,
          resetLocalSearch,
        });
      } else {
        propSetFilter("subCategory", value);
      }
    };

    return createMultipleSelect(
      "Sub Category",
      [...enabledSubCategoryOptions, ...disabledSubCategoryOptions],
      filters["subCategory"] || null,
      handleSubCategorySelect,
      () => propSetFilter("subCategory", "")
    );
  }, [
    subCategories,
    allSubCategories,
    filters,
    propSetFilter,
    propClearFilter,
    resetSearch,
    resetLocalSearch,
    createMultipleSelect,
  ]);

  const getDocumentStatusFilter = useCallback(() => {
    const options = documentStatusList.map((x) => ({
      label: x.name,
      key: x.id,
    }));
    return createSingleSelect(
      "documentStatusId",
      "Document Status",
      options,
      filters.documentStatusId,
      (value) => propSetFilter("documentStatusId", value ? value.key : null)
    );
  }, [documentStatusList, filters.documentStatusId, propSetFilter, createSingleSelect]);

  const getAllRevisionFilter = useCallback((className) => (
    <Switch
      className={className}
      checked={filters.showAllRevision}
      onChange={(e) => propSetFilter("showAllRevision", e)}
      size={"small"}
      aria-label="Show all revisions"
    />
  ), [filters.showAllRevision, propSetFilter]);

  useEffect(() => {
    // Only attempt to load filters when we have a valid siteId and are not already loading
    if (
      stableFilters.siteId &&
      !loadingAllFilters &&
      (!propDocumentFilters || propDocumentFilters.length === 0)
    ) {
      getDocumentFilters(stableFilters, true);
    }
  }, [loadingAllFilters, stableFilters, propDocumentFilters, getDocumentFilters]);

  const renderCustomFilters = (currentFilters) => {
    // Skeletons are only for the very first load. Once the filters exist we keep
    // them mounted through refreshes so selections stay visible, and show a
    // per-filter spinner instead of collapsing the whole panel.
    const hasFilters = propDocumentFilters?.length > 0;

    if (loadingAllFilters && !hasFilters) {
        return Array(propDocumentFilters?.length || 1).fill(0).map((_, index) => (
            <div key={index}>
                <Skeleton.Input active={true}  style={{ width: "100%" }} />
            </div>
        ));
    }
    return propDocumentFilters.map((item, index) => {
      const filterName = item.filterName.toLowerCase();

      return (
        <div className="document-filter-field" key={index}>
          {createMultipleSelect(
            item.filterLabel,
            item.values.map((x) => ({ key: x, label: x })),
            currentFilters[filterName] || null,
            (value) => {
              // The filter being changed keeps its own list; only the others
              // are refreshed, so it must not flip into a loading state.
              setActiveCustomFilter(filterName);
              propSetFilter(filterName, value);
            },
            () => {
              setActiveCustomFilter(filterName);
              propSetFilter(filterName, "");
            },
            loadingAllFilters && activeCustomFilter !== filterName
          )}
        </div>
      );
    });
  };

  const commonProps = {
    ignoreSite,
    getSiteFilter,
    getDocumentStatusFilter,
    getCategoryFilter,
    getSubCategoryFilter,
    renderCustomFilters,
    filters,
    getAllRevisionFilter,
    width
  };

  const layoutProps = {
    showFilterDrawer,
    width,
    closeFilterDrawer,
    getAllRevisionFilter,
    currentDashboard,
    tableCount,
    setLargeTableView,
    setThumbnailTableView,
    isCartTab,
    table,
    searchBarRef,
    ddvSearch,
    setDdvSearch,
    handleSearch,
    descriptionSearch,
    altSearch,
    setAltSearch,
    setDescriptionSearch,
    filterActionRef,
    filterRef
  };

  const sideViewFilterActions = (
    <FilterActions
      filterActionRef={filterActionRef}
      handleSearch={handleSearch}
      ddvSearch={ddvSearch}
      descriptionSearch={descriptionSearch}
      altSearch={altSearch}
      handleClearAll={handleClearAll}
      resetSearch={resetSearch}
      resetLocalSearch={resetLocalSearch}
      sideView={true}
      shouldAttachRef={sideView}
    />
  );

  const topViewFilterActions = (
    <FilterActions
      filterActionRef={filterActionRef}
      handleSearch={handleSearch}
      ddvSearch={ddvSearch}
      descriptionSearch={descriptionSearch}
      altSearch={altSearch}
      handleClearAll={handleClearAll}
      resetSearch={resetSearch}
      resetLocalSearch={resetLocalSearch}
      sideView={false}
      shouldAttachRef={!sideView}
    />
  );

  //const layoutToggle = <LayoutToggleComponent block={sideView || (width <= 1440 && width >= 768)} />;

  return (
    <>
      {sideView ? (
        <DefaultSideViewLayout 
          {...layoutProps} 
          actions={sideViewFilterActions}
          shouldAttachFilterRef={sideView}
          //layoutToggle={layoutToggle}
        >
          <FilterControls {...commonProps} sideView={true} />
        </DefaultSideViewLayout>
      ) : (
        <TopViewLayout 
          {...layoutProps} 
          actions={topViewFilterActions}
          customFilters={renderCustomFilters(filters)}
          shouldAttachFilterRef={!sideView}
          //layoutToggle={layoutToggle}
        >
          <FilterControls {...commonProps} sideView={false} />
        </TopViewLayout>
      )}
    </>
  );
};

const NO_ITEMS = [];
const EMPTY = {};

const DocumentFiltersContainer = (props) => {
  const { table } = props;
  const dispatch = useDispatch();

  const filtersKey = useSelector((state) => get(state.documentFilters, "key"));
  const filters = useSelector(
    (state) => get(state.shared, `${table}.filters`) || EMPTY
  );
  const categories = useSelector(
    (state) => get(state.documentFilters, `${table}.categories`) || NO_ITEMS
  );
  const subCategories = useSelector(
    (state) => get(state.documentFilters, `${table}.subCategories`) || NO_ITEMS
  );
  const allCategories = useSelector(
    (state) => get(state.documentFilters, `${table}.allCategories`) || NO_ITEMS
  );
  const allSubCategories = useSelector(
    (state) =>
      get(state.documentFilters, `${table}.allSubCategories`) || NO_ITEMS
  );
  const documentFilters = useSelector(
    (state) =>
      get(state.documentFilters, `${table}.customDocumentFilters`) || NO_ITEMS
  );
  const documentStatusList = useSelector(
    (state) => state.documentFilters.documentStatusesList
  );
  const loadingAllFilters = useSelector(
    (state) => state.documentFilters.loadingAllFilters
  );
  const cartDocumentIds = useSelector(
    (state) => state.cartManagement.dashboardCartDocumentIds || NO_ITEMS
  );
  const currentSiteId = useSelector(
    (state) =>
      get(state.shared, "siteId") ||
      get(state.userDetails, "setting.defaultSiteId")
  );

  const handleSetFilter = useCallback(
    (name, value) => {
      dispatch(setFilter(table, name, value));
    },
    [dispatch, table]
  );

  const handleGetDocumentFilters = useCallback(
    (filterValues, updateCustomFilters) => {
      dispatch(getDashboardFilters(filterValues, table, updateCustomFilters));
    },
    [dispatch, table]
  );

  const handleClearSelectedItems = useCallback(() => {
    dispatch(setSelectedTableItems(table, [], []));
  }, [dispatch, table]);

  const handleSetCurrentPage = useCallback(
    (value) => {
      dispatch(setCurrentPage(table, value));
    },
    [dispatch, table]
  );

  const handleClearFilter = useCallback(
    (siteId) => {
      dispatch(clearFilter(table, siteId));
    },
    [dispatch, table]
  );

  return (
    <DocumentFiltersComponent
      {...props}
      key={filtersKey}
      filters={filters}
      categories={categories}
      subCategories={subCategories}
      allCategories={allCategories}
      allSubCategories={allSubCategories}
      documentFilters={documentFilters}
      documentStatusList={documentStatusList}
      loadingAllFilters={loadingAllFilters}
      cartDocumentIds={cartDocumentIds}
      currentSiteId={currentSiteId}
      setFilter={handleSetFilter}
      getDocumentFilters={handleGetDocumentFilters}
      clearSelectedItems={handleClearSelectedItems}
      setCurrentPage={handleSetCurrentPage}
      clearFilter={handleClearFilter}
    />
  );
};

export default DocumentFiltersContainer;
